
    import * as React from 'react';

    const Expand16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M8.375 8.375V14h-.75V8.375H2v-.75h5.625V2h.75v5.625H14v.75H8.375z" /></svg>
        </div>
      );
    };

    Expand16.displayName = 'Expand16';

    export default Expand16;
  